/**
 * buildInfo · v2.7.65+E224
 * ────────────────────────
 * Single source of truth for the deployed build version + a preview-vs-
 * production environment detector. Rendered as a badge in the Admin Console
 * sidebar footer so an operator can instantly confirm whether the LIVE site
 * (bullertaxi.com) is running the latest fixes.
 *
 * ⚠️ MAINTENANCE: bump BUILD_VERSION + BUILD_DATE whenever shipping a change.
 * The value is baked into the bundle at build time, so after a redeploy
 * production shows the new version; if production still shows an older
 * version than preview, there are undeployed fixes.
 */
export const BUILD_VERSION = "2.7.65+E255";
export const BUILD_DATE = "2026-06-10";

export function getBuildEnv() {
  if (typeof window === "undefined") return { key: "server", label: "SERVER" };
  const h = (window.location.hostname || "").toLowerCase();
  if (h === "bullertaxi.com" || h === "www.bullertaxi.com") return { key: "production", label: "PRODUCTION" };
  if (h.includes("preview.emergentagent")) return { key: "preview", label: "PREVIEW" };
  if (h === "localhost" || h === "127.0.0.1" || h === "") return { key: "local", label: "LOCAL" };
  // Any other host (custom staging) → treat as a non-production build.
  return { key: "preview", label: "PREVIEW" };
}
